import type { ElementType } from 'react';

import { View } from '#internal/components/View';
import { createClassName } from '#internal/utils/classname';

import styles from './Dialog.module.css';

import { Close } from './Close';

import type { ContainerProps } from './Dialog.types';

const classnameDefault = 'ui-Dialog-Container';

export const Container = <T extends ElementType>(props: ContainerProps<T>) => {
  const { as = 'div', className, children, onClose, ...restProps } = props;

  const modifiers = {};

  const classname = createClassName({
    styles,
    baseName: classnameDefault,
    modifiers,
    className,
  });

  return (
    <View as={as} className={classname} {...restProps}>
      {onClose && <Close onClose={onClose} />}
      {children}
    </View>
  );
};
